import React from 'react';
import useIntls from '@opm/hooks/useIntls';
import { TOptionsItem } from '../../types';

interface CustomRangeSelectButtonProps {
  value: string;
  options: TOptionsItem[];
  title: string;
  titleCn: string;
  itemRender?: (item: TOptionsItem, isEn: boolean) => string | JSX.Element;
  /** 当 value 不在 options 中时，添加新选项的回调 */
  addOption?: (value: string, unit: string) => TOptionsItem | void;
  unit?: string;
}

export const renderOptionItem = (
  item: TOptionsItem,
  isEn: boolean,
  itemRender?: (item: TOptionsItem, isEn: boolean) => string | JSX.Element,
) => {
  if (itemRender) {
    return itemRender(item, isEn);
  }
  return isEn ? item.text : item.textCn;
};

export function CustomRangeSelectButton({
  value,
  options,
  title,
  titleCn,
  itemRender,
  addOption,
  unit,
}: CustomRangeSelectButtonProps) {
  const { isEn } = useIntls();

  let item = options.find((opt) => opt.value === value);

  // 如果找不到对应选项且有 addOption 方法，尝试添加新选项
  if (!item && value && addOption) {
    const newItem = addOption(value, unit);
    if (newItem) {
      item = newItem;
    }
  }

  const text = item ? renderOptionItem(item, isEn, itemRender) : '';

  return (
    <div className="dbom-dropdow-button">
      <label className="dbom-dropdow-button-label">
        {isEn ? title : titleCn}
      </label>
      <div className="dbom-dropdow-button-value">{text}</div>
    </div>
  );
}
